import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
export const Route = createFileRoute("/events/new")({
  component: lazyRouteComponent(
    () => import("@/pages/EventsPage"),
    "EventCreatePage",
  ),
});
